/* eslint-disable */
import React, { createRef, useState, useEffect } from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-router-dom';
import { DataLayer } from '~/components/DataLayer';
import { Img } from '~/components/Elements/Img';
import { PaperClip } from '~/components/PaperClip';
import { FiatBrand } from '~/components/FiatBrand';
import { Quote } from '~/components/Quote';
import configData from '~/config/data';
import css from './FooterPage.scss';

const classes = {
	root: css.footerPage,
	content: css.footerPageContent,
	paperClip: css.footerPagePaperClip,
	quote: css.footerPageQuote,
	nav: css.footerPageNav,
	navList: css.footerPageNavList,
	navItem: css.footerPageNavItem,
	navButton: css.footerPageNavButton,
	socialNav: css.footerPageSocialNav,
	socialNavList: css.footerPageSocialNavList,
	socialNavItem: css.footerPageSocialNavItem,
	socialNavButton: css.footerPageSocialNavButton,
	facebook: css.facebook,
	youtube: css.youtube,
	twitter: css.twitter,
	instagram: css.instagram,
	legal: css.footerPageLegal,
	logo: css.footerPageLogo,
	logoIbama: css.footerPageLogoIbama,
	fiat: css.footerPageFiat,
	fiatBrand: css.footerPageFiatBrand,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	data: PropTypes.object,
};

const defaultProps = {
	className: '',
	classes,
	data: configData.footer,
};

export function FooterPage({ className, classes, data: info, ...props }) {
	const $el = createRef();
	const [data, setData] = useState(info.data);

	const renderNavAnchor = (item, index) => {
		return (
			<li key={index} className={cls(classes.navItem)}>
				<DataLayer onEvent={item.dataLayerId || 'FooterPage_ClicouNavItem'} args={[item.label]}>
					<a
						className={cls(classes.navButton)}
						dangerouslySetInnerHTML={{ __html: item.label }}
						href={item.href}
						target={item.target}
					/>
				</DataLayer>
			</li>
		);
	};

	const renderNavLink = (item, index) => {
		return (
			<li key={index} className={cls(classes.navItem)}>
				<DataLayer onEvent={item.dataLayerId || 'FooterPage_ClicouNavItem'} args={[item.label]}>
					<Link className={cls(classes.navButton)} dangerouslySetInnerHTML={{ __html: item.label }} to={item.to} />
				</DataLayer>
			</li>
		);
	};

	const renderNav = (list) => {
		return list.map((item, index) => {
			if (item.to) return renderNavLink(item, index);
			return renderNavAnchor(item, index);
		});
	};

	const renderSocialItem = (item, index) => {
		return (
			<li key={index} className={cls(classes.socialNavItem)}>
				<DataLayer onEvent={item.dataLayerId || 'FooterPage_ClicouSocialItem'} args={[item.label]}>
					<a
						className={cls(classes.socialNavButton, classes[item.label.toLowerCase()])}
						href={item.href}
						target={item.target}>
						<i className={cls('fa', `fa-${item.label.toLowerCase()}`)} aria-hidden={true} />
					</a>
				</DataLayer>
			</li>
		);
	};

	const renderSocialNav = (list) => {
		return list.map(renderSocialItem);
	};

	return (
		<section
			ref={$el}
			id={FooterPage.displayName}
			data-ui-anchor={FooterPage.displayName}
			data-ui-hidemenu={true}
			className={cls(classes.root, className)}>
			<div className={cls(classes.content)}>
				{/* Decoration ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				<PaperClip className={cls(classes.paperClip)} align={PaperClip.ALIGN_LEFT} />

				{/* Fortune Cookie ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				<Quote className={cls(classes.quote)} title={data.title} text={data.description} />

				{/* Interno/Externo ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				<nav className={cls(classes.nav)}>
					<Fade bottom cascade>
						<ul className={cls(classes.navList)}>{renderNav(data.list)}</ul>
					</Fade>
				</nav>

				{/* Social ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				<nav className={cls(classes.socialNav)}>
					<Fade bottom cascade>
						<ul className={cls(classes.socialNavList)}>{renderSocialNav(data.social)}</ul>
					</Fade>
				</nav>

				{/* Legal ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				<Fade bottom>
					<p
						className={cls(classes.legal)}
						dangerouslySetInnerHTML={{
							__html: data.legal,
						}}
					/>
				</Fade>

				{/* Ibama ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				

				{/* Fiat brand ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				<div className={cls(classes.fiat)} aria-hidden={true}>
					<FiatBrand
						className={cls(classes.fiatBrand)}
						stripes={'italian'}
						stroke={'none'}
					/>
				</div>
			</div>
		</section>
	);
}

FooterPage.displayName = 'FooterPage';
FooterPage.propTypes = propTypes;
FooterPage.defaultProps = defaultProps;
export default FooterPage;
